import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneInput]',
  standalone: false
})
export class PhoneNumberDirective {
  readonly NOT_ALLOWED_CHARS = /[^0-9|+]/g;

  constructor(
    private control: NgControl,
    private el: ElementRef
  ) {}

  updateFormControl(value: string) {
    this.control.control.setValue(value);
  }

  // Adds + to the beginning of the phone, if there is not one already
  format(value) {
    if (value && value[0] !== '+') {
      value = '+' + value;
    }
    return value.replace(this.NOT_ALLOWED_CHARS, '');
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    let pastedInput: string = event.clipboardData.getData('text/plain').replace(/\D/g, '');

    if (pastedInput.length === 0) {
      pastedInput = '';
    }

    this.updateFormControl(this.format(pastedInput));
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    if (
      [46, 8, 9, 27, 13, 110, 190].indexOf(charCode) !== -1 ||
      // Allow: Ctrl+A
      (charCode === 65 && (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl+C
      (charCode === 67 && (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl+V
      (charCode === 86 && (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl+X
      (charCode === 88 && (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl+Z
      (charCode === 90 && (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: home, end, left, right
      (charCode >= 35 && charCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }

    const element = this.el.nativeElement;
    const value = element.value;

    // Allow + at the beginning of the input
    if (!value && (charCode === 43 || charCode === 187)) {
      return;
    }

    // Ensure that it is not a number and stop the keypress
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      event.preventDefault();
      return;
    }
  }
}
